/**
 * Ctrl+Alt+Shift+A — a beta tester's switch for Advanced mode (see
 * utils/advancedDesignerFlag.ts). Renders nothing; mounted once at the app
 * root, inside ToastProvider, so the confirmation shows on any route.
 *
 * `e.code` rather than `e.key`: with Alt held, macOS reports the key as "å".
 */

import React, { useEffect } from 'react';
import { useToast } from '../../../context/ToastContext';
import { toggleAdvancedDesignerFlag } from '../../../utils/advancedDesignerFlag';
import { DESIGNER_STRINGS as S } from '../strings';

export const AdvancedDesignerHotkey: React.FC = () => {
  const { showToast } = useToast();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!(e.ctrlKey && e.altKey && e.shiftKey) || e.code !== 'KeyA' || e.repeat) return;
      e.preventDefault();
      const on = toggleAdvancedDesignerFlag();
      showToast(on ? S.advanced.betaOn : S.advanced.betaOff, undefined, 'success');
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [showToast]);
  return null;
};

export default AdvancedDesignerHotkey;
